export default function (Site, $) {
  Site.widget("downArrow", {
    _create() {
      this.element.click(() => {
        $("html, body").animate(
          {
            scrollTop: $(".down-arrow").offset().top,
          },
          1000
        );
      });
    },
  });
}
